export default "__VITE_ASSET__CQAv3fcP__"